export const Formatting = {
    capitalizeFirstCharacter: function(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
};